import ReadOnlyField from "../../../../../Forms/ReadOnly/ReadOnlyField";
import StatusBadge from "./StatusBadge";

const ProductsInfoSection = ({ form }) => (
  <div className="mb-6 space-y-2">
    {/* Productos */}
    <p className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
      Productos
    </p>
    {form.details && form.details.length > 0 ? (
      <div className="space-y-1">
        {form.details.map((d: any) => (
          <ReadOnlyField
            key={d.id}
            label={d.productName}
            value={`${Number(d.quantity).toFixed(2)} ${d.unitCode ?? ''}`}
          />
        ))}
      </div>
    ) : (
      <ReadOnlyField label="Productos" value="Sin productos" />
    )}

    {/* Estado del traslado */}
    <div>
      <p className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
        Estado
      </p>
      <StatusBadge status={form.status} />
    </div>
  </div>
);

export default ProductsInfoSection;
